import React from 'react';
import ScreenComponent from "../../components/screenComponent";
import DivTable from "../../components/divTable";
import {Get, GetFile, Post} from "../../components/request";
import screens from "../../screens";
import {faDownload, faPencilAlt} from "@fortawesome/pro-solid-svg-icons";
import {withRouter} from "react-router-dom";
import {isEmpty, isString} from "lodash";
import MyCard from "../../components/myCard";
import {Alert, Button, Col, Form, Row} from "react-bootstrap";
import LabelToggle from "../../components/labelToggle";
import FormGroup from "../../components/formGroup";
import MyFile from "../../components/myFile";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Stages extends ScreenComponent {
    constructor(props) {
        super(props);
        this.state = {
            stages: [],
            stage: {},
            validateForm: false,
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Stages}`);

        this.setState({
            stages: body
        });
    }

    async save(event = false) {

        let url = `/v1/extranet/student/Stage`;
        let data;

        if (!isString(event)) {
            event.preventDefault();
            event.stopPropagation();

            if (event.currentTarget.checkValidity() === false) {
                return this.setState({
                    validateForm: !event.currentTarget.checkValidity()
                });
            }

            data = new FormData(event.currentTarget);
            data.append("StageID", this.state.stage.StageID);
            data = Object.fromEntries(data);

        } else {
            url += `?isFile=true&updated=${event}`;
            data = this.state.stage;
        }

        await Post(url, data, "Sauvegarde en cours..", {render: "Stage sauvegardé !"}, {render: "Erreur lors de la sauvegarde"});

        this.setState({
            stage: {},
        });

        this.componentDidMount();
    }

    renderForm() {
        return (
            <Form noValidate validated={this.state.validateForm} onSubmit={this.save.bind(this)}>

                <FormGroup label={"Thème du stage (100 caractères maximum)"}
                           name={"StageTheme"}
                           maxlength = {100}
                           defaultValue={this.state.stage.StageTheme}
                           required={true}/>

                <FormGroup label={"Date de début du stage"}
                           name={"StageDateDebut"}
                           type={"date"}
                           defaultValue={this.state.stage.StageDateDebut && this.state.stage.StageDateDebut.substr(0, 10)}
                           required={true}/>

                <FormGroup label={"Date de fin du stage"}
                           name={"StageDateFin"}
                           type={"date"}
                           defaultValue={this.state.stage.StageDateFin && this.state.stage.StageDateFin.substr(0, 10)}
                           required={true}/>

                <Row className={"mt-5"}>
                    <Col>
                        <Form.Group controlId="StageEntrepriseFamiliale">
                            <input type="hidden" name="StageEntrepriseFamiliale" value="false" />
                            <LabelToggle name="StageEntrepriseFamiliale" label="Entreprise familiale" value="true" />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="StageHorsBelgique">
                            <input type="hidden" name="StageHorsBelgique" value="false" />
                            <LabelToggle name="StageHorsBelgique" label="Hors Belgique (à l'étranger)" value="true" />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className={"mb-4"}>
                    <MyCard header={"Organisation et représentant"}
                            variant={"secondary"}
                            body={<>
                                <Row>
                                    <Col xs={12} md={6}>

                                        <FormGroup label={"Nom de l'organisation"}
                                                   name={"AdresseStageMemoireOrganisation"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireOrganisation}
                                                   required={true}/>

                                        <FormGroup label={"Nom du représentant"}
                                                   name={"AdresseStageMemoireNomRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireNomRepresentant}
                                                   required={true}/>

                                        <FormGroup label={"Prénom du représentant"}
                                                   name={"AdresseStageMemoirePrenomRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoirePrenomRepresentant}
                                                   required={true}/>

                                        <FormGroup label={"Fonction du représentant"}
                                                   name={"AdresseStageMemoireFonctionRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireFonctionRepresentant}/>

                                        <FormGroup label={"Email du représentant"}
                                                   type={"email"}
                                                   name={"AdresseStageMemoireEmailRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireEmailRepresentant}
                                                   required={true}/>

                                        <FormGroup label={"Téléphone du représentant"}
                                                   name={"AdresseStageMemoireTelephoneRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireTelephoneRepresentant}
                                                   required={true}/>


                                    </Col>
                                    <Col xs={12} md={6}>


                                        <FormGroup label={"Adresse de l'organisation"}
                                                   name={"AdresseStageMemoireAdresseRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireAdresseRepresentant}
                                                   required={true}/>

                                        <FormGroup label={"Suite de l'adresse"}
                                                   name={"AdresseStageMemoireSuiteAdresseRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireSuiteAdresseRepresentant}/>

                                        <FormGroup label={"Code postal de l'organisation"}
                                                   name={"AdresseStageMemoireCodePostalRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireCodePostalRepresentant}
                                                   required={true}/>

                                        <FormGroup label={"Localité de l'organisation"}
                                                   name={"AdresseStageMemoireLocaliteRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoireLocaliteRepresentant}
                                                   required={true}/>

                                        <FormGroup label={"Pays de l'organisation"}
                                                   name={"AdresseStageMemoirePaysRepresentant"}
                                                   maxlength="100"
                                                   defaultValue={this.state.stage.AdresseStageMemoirePaysRepresentant}
                                                   required={true}/>

                                    </Col>
                                </Row>
                            </>}/>
                </Form.Group>

                <FormGroup
                    label={"Commentaires sur les dates du stage"}
                    name={"StageCommentairesDates"}
                    required={true}
                    as={"textarea"}
                    defaultValue={this.state.stage.StageCommentairesDates}/>

                <FormGroup label={"Contenu du stage"}
                           name={"StageContenu"}
                           required={true}
                           as={"textarea"}
                           defaultValue={this.state.stage.StageContenu}/>

                <Button type="submit" variant="success" size={"lg"} block>
                    Sauvegarder
                </Button>
            </Form>
        );
    }

    renderText() {
        return (
            <Form noValidate validated={this.state.validateForm} onSubmit={this.save.bind(this)}>

                <p><u>Thème du stage</u>: {this.state.stage.StageTheme}</p>
                <p><u>Date de début du stage</u>: {new Date(this.state.stage.StageDateDebut).toLocaleDateString()}</p>
                <p><u>Date de fin du stage</u>: {new Date(this.state.stage.StageDateFin).toLocaleDateString()}</p>
                <p><u>Hors Belgique</u>: {this.state.stage.StageHorsBelgique ? 'oui' : 'non'}</p>
                <p style={{whiteSpace: "pre-wrap"}}><u>Commentaires sur les dates du
                    stage</u>: <br/>{this.state.stage.StageCommentairesDates}</p>
                <p style={{whiteSpace: "pre-wrap"}}><u>Contenu du stage</u>: <br/>{this.state.stage.StageContenu}</p>

                <Form.Group className={"mb-4"}>
                    <MyCard header={"Organisation et représentant"}
                            variant={"secondary"}
                            body={<>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <p><u>Nom de
                                            l'organisation</u>: {this.state.stage.AdresseStageMemoireOrganisation}</p>
                                        <p><u>Nom du
                                            représentant</u>: {this.state.stage.AdresseStageMemoireNomRepresentant}</p>
                                        <p><u>Prénom du
                                            représentant</u>: {this.state.stage.AdresseStageMemoirePrenomRepresentant}
                                        </p>
                                        <p><u>Fonction du
                                            représentant</u>: {this.state.stage.AdresseStageMemoireFonctionRepresentant}
                                        </p>
                                        <p><u>Email du représentant</u>: <a
                                            href={`mailto:${this.state.stage.AdresseStageMemoireEmailRepresentant}`}>{this.state.stage.AdresseStageMemoireEmailRepresentant}</a>
                                        </p>
                                        <p><u>Téléphone du
                                            représentant</u>: {this.state.stage.AdresseStageMemoireTelephoneRepresentant}
                                        </p>

                                    </Col>
                                    <Col xs={12} md={6}>

                                        <p><u>Adresse du représentant</u>:</p>
                                        <div>
                                            {this.state.stage.AdresseStageMemoireAdresseRepresentant}<br/>
                                            {this.state.stage.AdresseStageMemoireSuiteAdresseRepresentant}<br/>
                                            {this.state.stage.AdresseStageMemoireCodePostalRepresentant} {this.state.stage.AdresseStageMemoireLocaliteRepresentant}<br/>
                                            {this.state.stage.AdresseStageMemoirePaysRepresentant}<br/>
                                        </div>
                                    </Col>
                                </Row>
                            </>}/>
                </Form.Group>

                <Alert variant={"info"}>
                    Les fichiers s'enregistrent automatiquement après l'import dans le formulaire,<br/>
                    il faut ouvrir l'édition du stage pour ajouter chaque fichier un à un (pas en même temps).
                </Alert>

                {
                    this.state.stage.IsBACStage
                        ? (this.state.stage.StageFichierPreAccordID !== null
                            ? <div>
                                <Button className={"m-3"} size={"lg"} target={"_blank"}
                                        href={`${process.env.APP_API_ENDPOINT}/v1/files/${this.state.stage.StageFichierPreAccordID}`}>Pré
                                    accord</Button>
                            </div>
                            : <MyFile label={"Pré accord"}
                                      name={"StageFichierPreAccordID"}
                                      onChange={(id) => this.setState({
                                          stage: {
                                              ...this.state.stage,
                                              StageFichierPreAccordID: id
                                          }
                                      }, () => {
                                          this.save("PreAccord");
                                      })}
                            />
                        ) : ""
                }

                {
                    this.state.stage.StageFichierConventionID !== null
                        ? <div>
                            <Button className={"m-3"} size={"lg"} target={"_blank"}
                                    href={`${process.env.APP_API_ENDPOINT}/v1/files/${this.state.stage.StageFichierConventionID}`}>Convention
                                de stage</Button>
                        </div>
                        : <MyFile label={"Convention de stage"}
                                  name={"StageFichierConventionID"}
                                  onChange={(id) => this.setState({
                                      stage: {
                                          ...this.state.stage,
                                          StageFichierConventionID: id
                                      }
                                  }, () => {
                                      this.save("Convention");
                                  })}
                        />
                }

                {
                    this.state.stage.StageFichierEvaluationMaitreStageID !== null
                        ? <div>
                            <Button className={"m-3"} size={"lg"} target={"_blank"}
                                    href={`${process.env.APP_API_ENDPOINT}/v1/files/${this.state.stage.StageFichierEvaluationMaitreStageID}`}>Evaluation
                                du maître de stage</Button>
                        </div>
                        : <MyFile label={"Evaluation du maître de stage"}
                                  name={"StageFichierEvaluationMaitreStageID"}
                                  onChange={(id) => this.setState({
                                      stage: {
                                          ...this.state.stage,
                                          StageFichierEvaluationMaitreStageID: id
                                      }
                                  }, () => {
                                      this.save("EvaluationMaitreStage");
                                  })}
                        />
                }

            </Form>
        );
    }

    render() {
        return (
            <>
                <section>
                    <DivTable
                        columns={{"Thème": "StageTheme", "Organisation": "AdresseStageMemoireOrganisation"}}
                        array={this.state.stages}
                        actions={[{
                            onClick: (id) => {
                                this.setState({stage: this.state.stages.find(f => f.StageID === id)})
                            }, icon: faPencilAlt, title: "Editer"
                        }]}/>
                </section>
                <section>
                    {(this.state.stage.StageEncodageEtudiant)  && (
                    <Button
                        className="m-3"
                        size="lg"
                        target="_blank"
                        onClick={async () => {
                            await GetFile(
                                `/v1/files/printStage/${this.state.stage.StageID}/ConventionStage`,
                                null,
                                "Génération en cours...",
                                {
                                    render: (
                                        <>
                                            <FontAwesomeIcon className="mr-2" icon={faDownload} />
                                            Document généré !
                                        </>
                                    )
                                },
                                {
                                    render: (
                                        <>
                                            <FontAwesomeIcon className="mr-2" icon={faDownload} />
                                            Erreur lors du téléchargement...
                                        </>
                                    )
                                }
                            );
                        }}
                    >
                        Télécharger la convention à faire signer par l'entreprisee
                    </Button>
                        )}
                </section>
                <section>
                    {!isEmpty(this.state.stage) &&
                    <MyCard header={`Stage #${this.state.stage.StageID}`}
                            body={this.state.stage.StageEncodageEtudiant ? this.renderText() : this.renderForm()}/>}
                </section>
            </>
        );
    }
}

export default withRouter(Stages);